import { render } from "./VsudSwitch.vue?vue&type=template&id=e50a14da"
import script from "./VsudSwitch.vue?vue&type=script&lang=js"
export * from "./VsudSwitch.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__